"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderRootSaga = orderRootSaga;
var _effects = require("redux-saga/effects");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _actions = require("@otpusk/apisearch-toolbox/dist/offers/actions");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _actions2 = require("../../../../../../../bus/ui/actions");
var _config = require("../../../../../../../services/config");
var _bootstrapBookingOfferByOperator = require("../../../store/saga/bootstrapBookingOfferByOperator");
var _helpers = require("../../../store/helpers");
var _actions3 = require("../../../store/actions");
var _selectors4 = require("../../../store/selectors");
var _saga = require("../components/LoginRequestButton/store/saga");
var _actions4 = require("./actions");
var _constants = require("./constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(orderRootSaga);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function actualizeOfferSaga(_ref) {
  var _ref$payload = _ref.payload,
    offerID = _ref$payload.offerID,
    queryID = _ref$payload.queryID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var adults, children, activeCurrency, isActualizedOffer, actualizedOffer, _extractInitialActive, outbound, inbound, onActualizedOffer, callbackPayload;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions2.register)(_constants.UI_KEY_OF_ACTUALIZING_OFFER, {
            loading: true
          }));
        case 2:
          _context.next = 4;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              queryID: queryID,
              paramName: _fn.QUERY_PARAMS.ADULTS
            });
          });
        case 4:
          adults = _context.sent;
          _context.next = 7;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              queryID: queryID,
              paramName: _fn.QUERY_PARAMS.CHILDREN
            });
          });
        case 7:
          children = _context.sent;
          _context.next = 10;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getQueryParam)(state, {
              queryID: queryID,
              paramName: _fn.QUERY_PARAMS.CURRENCY
            });
          });
        case 10:
          activeCurrency = _context.sent;
          _context.next = 13;
          return (0, _effects.put)(_actions.offersActions.actualizeOffer(offerID, adults, children.toArray(), activeCurrency));
        case 13:
          _context.next = 15;
          return (0, _effects.take)(_actions.offersActions.endActualizeOffer);
        case 15:
          _context.next = 17;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.isActualizedOffer)()(state, {
              offerID: offerID
            });
          });
        case 17:
          isActualizedOffer = _context.sent;
          if (isActualizedOffer) {
            _context.next = 24;
            break;
          }
          _context.next = 21;
          return (0, _effects.select)(_selectors4.getIsShowBookingForOperatorForm);
        case 21:
          if (!_context.sent) {
            _context.next = 24;
            break;
          }
          _context.next = 24;
          return (0, _effects.put)((0, _actions3.setIsShowBookingForOperatorForm)(false));
        case 24:
          _context.next = 26;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getActualizedOffer)()(state, {
              offerID: offerID
            });
          });
        case 26:
          actualizedOffer = _context.sent;
          if (!actualizedOffer) {
            _context.next = 33;
            break;
          }
          _extractInitialActive = (0, _helpers.extractInitialActiveFlightsFromOffer)(actualizedOffer), outbound = _extractInitialActive.outbound, inbound = _extractInitialActive.inbound;
          _context.next = 31;
          return (0, _effects.all)([outbound && (0, _effects.put)((0, _actions3.setActiveOutboundFlight)(outbound)), inbound && (0, _effects.put)((0, _actions3.setActiveInboundFlight)(inbound))]);
        case 31:
          _context.next = 33;
          return (0, _effects.call)(_bootstrapBookingOfferByOperator.getIntegrationServicesSaga);
        case 33:
          if (!(isActualizedOffer && actualizedOffer)) {
            _context.next = 36;
            break;
          }
          _context.next = 36;
          return (0, _effects.put)(_actions.offersActions.setOffer(actualizedOffer.id, actualizedOffer));
        case 36:
          _context.next = 38;
          return (0, _effects.put)((0, _actions2.update)(_constants.UI_KEY_OF_ACTUALIZING_OFFER, {
            loading: false
          }));
        case 38:
          onActualizedOffer = (0, _config.getOnActualizedOffer)();
          if (!onActualizedOffer) {
            _context.next = 54;
            break;
          }
          _context.next = 42;
          return (0, _effects.select)(function (state) {
            return (0, _selectors3.getHotel)()(state, (0, _selectors2.getOffer)()(state, {
              offerID: offerID
            }).hotelId);
          });
        case 42:
          _context.t0 = _context.sent;
          _context.next = 45;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 45:
          _context.t1 = _context.sent;
          _context.next = 48;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getMessageByActualizedOffer)()(state, {
              offerID: offerID
            });
          });
        case 48:
          _context.t2 = _context.sent;
          _context.next = 51;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getActualizedStatus)()(state, {
              offerID: offerID
            });
          });
        case 51:
          _context.t3 = _context.sent;
          callbackPayload = {
            hotel: _context.t0,
            offer: _context.t1,
            message: _context.t2,
            status: _context.t3
          };
          onActualizedOffer(callbackPayload);
        case 54:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })();
}
function onShowBookingFormSaga(_ref2) {
  var _ref2$payload = _ref2.payload,
    onShow = _ref2$payload.onShow,
    offerID = _ref2$payload.offerID,
    hotelID = _ref2$payload.hotelID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var redirect;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(0, _config.isEnabledSimplifyBookingRedirect)()) {
            _context2.next = 5;
            break;
          }
          redirect = (0, _config.getOnRedirectToBookingsPage)();
          if (!redirect) {
            _context2.next = 5;
            break;
          }
          redirect(hotelID, offerID);
          return _context2.abrupt("return");
        case 5:
          _context2.next = 7;
          return (0, _effects.put)((0, _actions3.setIsShowBookingForOperatorForm)(true));
        case 7:
          if (onShow) {
            onShow();
          }
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })();
}
function orderRootSaga() {
  return _regeneratorRuntime().wrap(function orderRootSaga$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return (0, _effects.takeEvery)(_actions4.actualizeOffer, /*#__PURE__*/_regeneratorRuntime().mark(function actualizeOfferSagaDecorator(action) {
          var taskOfActualizing, _yield$race, _yield$race2, shouldCancellActualizing;
          return _regeneratorRuntime().wrap(function actualizeOfferSagaDecorator$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _effects.fork)(actualizeOfferSaga, action);
              case 2:
                taskOfActualizing = _context3.sent;
                _context3.next = 5;
                return (0, _effects.race)([(0, _effects.take)(_actions3.resetStore), (0, _effects.join)(taskOfActualizing)]);
              case 5:
                _yield$race = _context3.sent;
                _yield$race2 = _slicedToArray(_yield$race, 1);
                shouldCancellActualizing = _yield$race2[0];
                if (!shouldCancellActualizing) {
                  _context3.next = 11;
                  break;
                }
                _context3.next = 11;
                return (0, _effects.cancel)(taskOfActualizing);
              case 11:
              case "end":
                return _context3.stop();
            }
          }, actualizeOfferSagaDecorator);
        }));
      case 2:
        _context4.next = 4;
        return (0, _effects.takeEvery)(_actions4.showBookingForm, onShowBookingFormSaga);
      case 4:
        _context4.next = 6;
        return (0, _effects.call)(_saga.loginRequestButtonSaga);
      case 6:
      case "end":
        return _context4.stop();
    }
  }, _marked);
}